// eslint-disable-next-line import/no-extraneous-dependencies
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";

import { IssueReportForm } from "../pages/home/steps";
import { AcknowledgementPage } from "../pages/acknowledgment";

import { RoutesPath } from "./routes";
import { ErrorPage } from "../pages/error";
import { WelcomeMobilePage } from "../pages/welcomeMobilePage";
import { MainLayout } from "../components/templates";
import { SnackbarProvider } from "notistack";
import { MainContext } from "../context";

const LayoutWrapper = () => {
  return (
    <MainContext>
      <MainLayout>
        <SnackbarProvider>
          <Outlet />
        </SnackbarProvider>
      </MainLayout>
    </MainContext>
  );
};

const router = createBrowserRouter(
  [
    {
      element: <LayoutWrapper />,
      children: [
        { path: RoutesPath.WELCOME_MOBILE, element: <WelcomeMobilePage /> },
        { path: RoutesPath.HOME, element: <IssueReportForm /> },
        { path: RoutesPath.ACKNOWLEDGMENT, element: <AcknowledgementPage /> },
        { path: RoutesPath.ERROR, element: <ErrorPage /> },
        { path: RoutesPath.ANY, element: <div>Page not found 404</div> },
      ],
    },
  ],
  { basename: "/" },
);

export const MainRouter = () => <RouterProvider router={router} />;
